module.exports = __webpack_public_path__ + "img/project3.4a466087.webp";